module.exports = {
  common: {
    instagramLink: "https://www.instagram.com/hk_marketplace/",
    facebookLink: "https://www.facebook.com/marketplacehongkong",
    youtubeLink: "https://www.youtube.com/channel/UCbZNuy8dP-66eD1nY-4B5Xg",
    wellCenter: "Market Place Shop help center",
    searchPlaceholder: "Searching in Market Place"
  },
  footer: {
    aboutShop: "About Market Place",
    followUs: "Follow us on",
    coptyRight: "© 2024 Wellcome / Market Place. The Dairy Farm Company Limited. All rights reserved.",
    ourStory: "Our Story",
    ourStoryLink: "https://www.marketplacehk.com/en/d/SwxfFYOJm0tPzR.html",
    corporateResponsibility: "Community",
    corporateResponsibilityLink: "https://www.marketplacebyjasons.com/community",
    storeLocatorLink: "/en/store_locator",
    careersLink: "https://joinus.dfiretailgroup.com/jobs/search",
    corporatePromotionsLink: "https://www.marketplacebyjasons.com/stamp-programme",
    foodPermitsLink: "/dl/All_Marketplacehk.com_2024.pdf",
    foodPermitsName: "Market Place license.pdf",
    tel: "+852 3001 1299",
    emailLink: "cs@marketplacebyjasons.com",
    privacyPolicyLink: "https://www.marketplacebyjasons.com/privacy-policy",
    termsAndConditionsLink: "https://www.marketplacehk.com/en/d/hcDR1FBqZ4.html",
    wellcomeWhatsAppTermsAndConditions: "Market Place WhatsApp Terms and Conditions",
    regardHreesixty: "About 3hreesixty",
    regardHreesixtyLink: "https://www.marketplacehk.com/en/d/rQkyELZn3KPlAmzS.html",
    wellcomeWhatsAppTermsAndConditionsLink: "https://www.marketplacebyjasons.com/node/431",
    contactUsLink: "https://www.marketplacebyjasons.com/index.php/contact-us",
    download: "Delicious food and wine at your fingertips",
    appStoreLink: "https://apps.apple.com/us/app/market-place-online-shop/id1513522092",
    goolePlayLink: "https://play.google.com/store/apps/details?id=com.rtasia.intl&hl=en&gl=US",
    emailBulkorderLink: "Business@marketplacehk.com",
    b2bBulkOrdersEnquires: "B2B & Bulk Order Enquires"
  },
  page: {
    siteName: "Market Place",
    siteUrl: "https://www.marketplacehk.com",
    title: "Market Place Online Shop",
    description:
      "Shop at Market Place Online Shop to discover and get inspired by our wide range of great quality food and wine at great prices. Enjoy free shipping over $500. Spend $150 or more and enjoy the free Click & Collect service!"
  },
  pageTitle: {
    cart: "My Cart | Market Place Online Shop",
    checkout: "Secure Checkout | Market Place Online Shop",
    cards: "My Cards | Market Place Online Shop",
    coupons: "My Coupons | Market Place Online Shop",
    order_list: "My Orders | Market Place Online Shop",
    order_details: "Order Details | Market Place Online Shop",
    cashier: "Checkout Cashier | Market Place Online Shop",
    payment: "Payment Successful | Market Place Online Shop",
    categoryName: "{name} | Market Place Online Shop",
    storeLocator: "Store Locator | Market Place Online Shop"
  },
  productDetails: {
    freshnessInfo: "Market Place promises this item will stay fresh for {num} days, including the day of delivery."
  },
  order: {
    banner:
      "All orders are synced from the Market Place app. Some orders might be split, but we will deliver them together for each purchase.",
    syncedOrder: "Current order is synced from Market Place app.",
    goToAppTips: "Please go to our Market Place app and check more details"
  },
  orderDetails: {
    productdisabledTitle: "View item details with Market Place app"
  },
  cart: {
    rangeStandardDeliveryTitle:
      "The following items cannot be delivered to you, please enjoy the full shopping experience in our Market Place app",
    unRangeStoreGroupTitle:
      'The following items cannot be delivered to you with "Express" or "Pre-Order" store in the website yet, please enjoy the full shopping experience in our Market Place app',
    slaveStoreMsg:
      "Seamlessly check out items from other stores synced with your Market Place app on the Wellcome website",
    slaveStoreTip: "View item details with Market Place app"
  },
  getTheApp: {
    title: "Wellcome mobile is better on the Market Place app  ",
    description: "For an optimized mobile experience, shop in Market Place Online Shop now!",
    goTo: "Go to Market Place"
  },
  header: {
    feedbackLink: "https://yuu.qualtrics.com/jfe/form/SV_8erEI4Mn8qdgDps",
    customerCareLink: "https://www.marketplacebyjasons.com/contact-us"
  }
}
